import React, { useState } from 'react';
import { DateInput } from 'components/commons';

const SearchComponent = (props) => {
	const { getData, tabAfiliations } = props;

	const [date, setDate] = useState(new Date());
	const [error, setError] = useState('');

	const handleDate = (value) => {
		let date = new Date(value);
		const year = date.getFullYear();
		const month = date.getMonth() + 1;

		setDate(value ? value : new Date());

		const dateCustom =
			year < 2020 ? null : `${year}-${month <= 9 ? `0${month}` : `${month}`}-1`;
		getData(dateCustom);

		if (date === null || date > new Date())
			setError('Seleccione una fecha válida');
		else setError('');
	};

	const label = tabAfiliations === true ? 'afiliaciones' : 'aliados';

	return (
		<div className="flex justify-center">
			<DateInput
				name="date"
				label={`Mostrar ${label} por fecha`}
				placeholder="Seleccione la fecha"
				required={true}
				maxDate={new Date()}
				helperText={error}
				errors={error}
				value={date}
				addClass="wInputThree"
				onChange={(value) => handleDate(value)}
			/>
		</div>
	);
};

export default SearchComponent;
